import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const Footer = () => {
  const { settings } = useApp();

  return (
    <footer className="bg-white text-brand-dark py-16 mt-auto border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/0d1a77bee3ae789007ea5ef360df1d387ec1e85717a1017af2b0c3483a4e466cd39e9bbe534d979be486fb8af10a0ba5/images/aW1hZ2UvcG5n/c5ac90f76000b484186dd837b16d1cf8.png" 
              alt="Golden Compass Logo" 
              className="h-20 w-auto object-contain mb-4" 
            />
            <p className="text-gray-500 font-serif italic max-w-xs">
              Travel guidance for real people, real questions, and real next steps.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-8 text-sm font-semibold tracking-wide uppercase">
            <Link to="/" className="hover:text-brand-green transition-colors decoration-brand-gold decoration-2 underline-offset-4 hover:underline">
              Start Here
            </Link>
            <Link to="/about" className="hover:text-brand-green transition-colors decoration-brand-gold decoration-2 underline-offset-4 hover:underline">
              About Us
            </Link>
            <a 
              href={settings.youtubeUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-brand-green transition-colors decoration-brand-gold decoration-2 underline-offset-4 hover:underline"
            >
              YouTube Channel
            </a>
          </div>
        </div>
        
        <div className="mt-16 pt-8 border-t border-gray-50 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-medium text-gray-400">
          <p>© {new Date().getFullYear()} Golden Compass Travel Guides. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-brand-dark transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-brand-dark transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;